// export const tmsApi = `${process.env.PUBLIC_URL}/api/`;
// export const tmsApi = `https://tmsapi.megacabs.com/api/`;
// export const invoiceApi = `https://kiosk.megacabs.com/`;
export const tmsApi = `https://dev.megacabs.com/tms/api/`;
export const invoiceApi = `https://dev.megacabs.com/kiosk/`;
// export const tmsApi = `http://192.168.106:8080/api/`;
// export const tmsApi = 'http://43.205.86.19:8085/api/' 
export const localApi = `${process.env.PUBLIC_URL}/api/`;
export const megaFavicon = 'https://new-megacabs-logo.s3.ap-south-1.amazonaws.com/mega_favicon.png'
export const megaLogo = 'https://new-megacabs-logo.s3.ap-south-1.amazonaws.com/mega_logo_blue.png'






export const extApi=`https://dev.megacabs.com/thirdparty/api/`
// export const extApi=`https://thirdpartyapi.megacabs.com/api/`

